import React from "react";

/**
 * Brand assets for Documento Express.
 * The provided horizontal logo already contains the "de" symbol + wordmark,
 * so we use it as a single image in the header and footer.
 */
export const LOGO_FULL =
  "https://customer-assets.emergentagent.com/job_digital-comms-3/artifacts/bvasez7f_logo_docex.png";

// Backwards-compatible aliases.
export const LOGO_MARK = LOGO_FULL;
export const LOGO_HORIZONTAL = LOGO_FULL;

export const BrandMark = ({ size = 36, className = "" }) => (
  <img
    src={LOGO_FULL}
    alt="Documento Express"
    className={`select-none ${className}`}
    style={{ height: size, width: "auto", objectFit: "contain" }}
    draggable={false}
  />
);

/**
 * BrandWordmark
 * - If `className` includes a Tailwind height (h-*), it takes precedence
 *   and a responsive size can be applied externally.
 * - Otherwise falls back to the numeric `height` prop.
 */
export const BrandWordmark = ({ height = 36, className = "" }) => {
  const hasTwHeight = /\bh-/.test(className);
  return (
    <div className="flex items-center" data-testid="brand-wordmark">
      <img
        src={LOGO_FULL}
        alt="Documento Express"
        className={`select-none object-contain ${className}`}
        style={hasTwHeight ? { width: "auto" } : { height, width: "auto" }}
        draggable={false}
      />
    </div>
  );
};

export default BrandWordmark;
